import { RouteObject } from "react-router-dom";
import { ProfilePage } from "../features/profile/pages/profile.page";
import { SettingsPage } from "../features/settings/pages/settings.page";
import { PoliciesPage } from "../features/policies/pages/policies.page";
import { WithAuth } from "../components/layout/with-auth/with-auth.component";
import { Logout } from "../features/logout/pages/logout.page";
import { ViewFilm } from "../features/films/pages/view.page";
import { NotFoundPage } from "../misc/not-found.page";

export const miscellaneousRoutes: RouteObject[] = [
  {
    path: "/profile",
    element: (
      <WithAuth>
        <ProfilePage />
      </WithAuth>
    ),
  },
  {
    path: "/settings",
    element: (
      <WithAuth>
        <SettingsPage />
      </WithAuth>
    ),
  },
  {
    path: "/policies",
    element: (
      <WithAuth>
        <PoliciesPage />
      </WithAuth>
    ),
  },
  {
    path: "/logout",
    element: (
      <WithAuth>
        <Logout />
      </WithAuth>
    ),
  },
  {
    path: "/film/:customURL",
    element: <ViewFilm />,
  },
  {
    path: "/:customURL",
    element: <NotFoundPage />,
  },
  {
    path: "/:customURL/edit",
    element: <NotFoundPage isEditing />,
  },
];
